<template>
  <div>
    <h1>TEST APPLICANTS PAGE</h1>
    <p>This is a test page</p>
  </div>
</template>

<script>
export default {
  name: 'TestApplicants'
}
</script>